import { supabase } from '@/lib/supabase'

export type NavConfigItem = { key: string; label?: string; visible?: boolean; icon?: string }
export type NavLayout = 'sidebar' | 'header'

const LAYOUT_KEY = '__layout__'

export async function getNavConfig(role: 'master'|'member'|'afiliado'): Promise<NavConfigItem[]> {
  const { data, error } = await supabase.rpc('get_nav_config_for', { p_role: role })
  if (error) throw error
  const arr = (data as any) ?? []
  if (Array.isArray(arr)) return arr
  return []
}

export async function setNavConfig(role: 'master'|'member'|'afiliado', items: NavConfigItem[]): Promise<void> {
  const { error } = await supabase.rpc('set_nav_config_for', { p_role: role, p_config: items })
  if (error) throw error
}

export async function getNavLayout(role: 'master'|'member'|'afiliado'): Promise<NavLayout> {
  try {
    const cfg = await getNavConfig(role)
    const meta = (cfg || []).find(it => it.key === LAYOUT_KEY)
    const v = (meta?.label || '').toLowerCase()
    return v === 'header' ? 'header' : 'sidebar'
  } catch {
    return 'sidebar'
  }
}

export async function setNavLayout(role: 'master'|'member'|'afiliado', layout: NavLayout): Promise<void> {
  const cfg = await getNavConfig(role)
  const rest = (cfg || []).filter(it => it.key !== LAYOUT_KEY)
  const meta: NavConfigItem = { key: LAYOUT_KEY, label: layout, visible: true }
  await setNavConfig(role, [meta, ...rest])
}
